// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__tIirw","button":"Tooltip_button__hKVLj","flex":"Tooltip_flex__FvR6-","icon":"Tooltip_icon__llCoz"};